export const TRPC_SETTINGS = {
  QUERY_NO_REFETCH: {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  }
} as const;
